var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconExcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.7 7.5-5.46-6.33-1.08-1.25H9.26a3.13 3.13 0 0 0-3.13 3.14v3.98h1.94V3.82c0-.98.79-1.77 1.76-1.77h11.03v5.22a3.52 3.52 0 0 0 3.53 3.53h3.82L28 25.88c0 .97-.78 1.75-1.75 1.76l-16.57-.01c-.89 0-1.6-.87-1.6-1.94V24.4H6.13v1.9c0 1.92 1.28 3.47 2.85 3.47h17.84a3.14 3.14 0 0 0 3.13-3.14V8.97L28.7 7.5",
    fill: "gray"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.22 25.38H0V6.07h20.22v19.31M1.94 23.44h16.34V8H1.94",
    fill: "#08743B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#08743B",
    d: "M15.73 20.82h-3.41L10 17.54l-2.44 3.28H4.14l4.24-5.33-3.42-4.67h3.45l1.61 2.54 1.71-2.54h3.51l-3.59 4.67 4.08 5.33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExcel);
export default ForwardRef;